import { Video, X, Check } from "lucide-react";

const WebcamRequestModal = ({ 
  fromUser, 
  onAccept, 
  onDeny, 
  onClose 
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-testid="webcam-request-modal">
      <div className="retro-window w-[350px]">
        <div className="retro-title-bar">
          <span className="flex items-center gap-1">
            <Video className="w-3 h-3" />
            Webcam Request
          </span>
          <button 
            className="retro-button px-2 py-0 text-xs"
            onClick={onClose}
          >
            <X className="w-3 h-3" />
          </button>
        </div>

        <div className="p-4 bg-[#C0C0C0]">
          <div className="retro-inset p-4 mb-4 text-center">
            <Video className="w-12 h-12 mx-auto mb-3 text-[#7B0099]" />
            <p className="font-verdana text-sm font-bold mb-2">
              Webcam View Request
            </p>
            <p className="font-arial text-xs text-[#666]">
              <span className="font-bold text-[#000080]">{fromUser?.username}</span> wants to view your webcam.
            </p>
            <p className="font-arial text-xs text-[#808080] mt-2">
              If you accept, they will be able to see your camera feed.
            </p>
          </div>

          <div className="flex gap-2 justify-center">
            <button 
              className="retro-button px-4 py-2 bg-green-100 flex items-center gap-2"
              onClick={() => {
                onAccept(fromUser);
                onClose();
              }}
              data-testid="accept-webcam-btn"
            >
              <Check className="w-4 h-4 text-green-600" />
              <span className="text-xs">Allow</span>
            </button>
            <button 
              className="retro-button px-4 py-2 bg-red-100 flex items-center gap-2"
              onClick={() => {
                onDeny(fromUser);
                onClose();
              }}
              data-testid="deny-webcam-btn"
            >
              <X className="w-4 h-4 text-red-600" />
              <span className="text-xs">Deny</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebcamRequestModal;
